import React, { useState } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings2.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";
import { ReactComponent as Package } from "feather-icons/dist/icons/package.svg";
import { useHistory } from "react-router-dom";

const Subheading = tw(SubheadingBase)`mb-4 text-center`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center mx-auto`;

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`mt-12 max-w-4xl relative w-full`;
const FAQ = tw.div`cursor-pointer select-none mt-5 px-8 sm:px-10 py-5 sm:py-4 rounded-lg text-gray-800 hover:text-gray-900 bg-gray-200 hover:bg-gray-300 transition duration-300`;
const Question = tw.dt`flex justify-between items-center`;
const QuestionText = tw.span`text-lg lg:text-xl font-semibold sm:w-9/12`;
const QuestionToggleIcon = motion.custom(styled.span`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`);
const Answer = motion.custom(tw.dd`flex justify-between pointer-events-none text-sm sm:text-base sm:mr-12 mr-0 leading-relaxed`);

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-56 w-56 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

const BuyButton = styled.button`
  ${tw`hidden tracking-wide font-semibold bg-orange-500 text-gray-100 w-3/12 py-4 rounded hover:bg-orange-900 transition-all duration-300 ease-in-out sm:flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

const BuyButton2 = styled.button`
  ${tw`sm:hidden mt-4 tracking-wide font-semibold bg-orange-500 text-gray-100 w-full py-4 rounded hover:bg-orange-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

export default ({
  subheading = "FAQS",
  heading = "You have Questions ?",
  description = "Please choose the desired service provider and add your address details for the doorstep pickup",
  faqs = [
    {
      vendor: "FedEx",
      gstrate:
        "Yes, it is, if you have a membership with us. Otherwise it is charged as per the menu. Some limits do apply as to how much items can be included in your lunch. This limit is enough for any one person and merely exists to discourage abusal of the system."
    },
    {
      vendor: "DHL",
      gstrate:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      vendor: "UPS",
      gstrate:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    }
  ],
  BuyButtonIcon = Package,
  dataload = ""
}) => {

  const history = useHistory();
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  const onService = (ser) => {
    if (dataload) {
      if (ser !== "cargo sailors")
        history.push({
          pathname: '/user-details',
          state: [dataload, { service: ser }]
        })
      else
        history.push({
          pathname: '/user-domestic-details',
          state: [dataload, { service: "domestic" }]
        })
    }
    else
      history.push('/')
  }

  return (
    <Container>
      <ContentWithPaddingXl>
        <Column>
          <HeaderContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
          </HeaderContent>
          <FAQSContainer>
            <p tw="text-center text-xs text-orange-500 font-bold">Click to see more detailed price</p>
            {faqs.map((faq, index) => (
              <FAQ
                key={index}
                onClick={() => {
                  toggleQuestion(index);
                }}
                className="group"
              >
                <Question>
                  <QuestionText>{faq.vendor}</QuestionText>
                  {faq.totalprice !== undefined ?
                    <BuyButton onClick={() => onService((faq.vendor).toLowerCase())}>
                      <BuyButtonIcon className="icon" />
                      <span className="text">₹ {faq.totalprice}</span>
                    </BuyButton> :
                    <BuyButton tw="bg-orange-400!">
                      <BuyButtonIcon className="icon" />
                      <span className="text">Unavailable</span>
                    </BuyButton>}
                  <QuestionToggleIcon
                    variants={{
                      collapsed: { rotate: 0 },
                      open: { rotate: -180 }
                    }}
                    initial="collapsed"
                    animate={activeQuestionIndex === index ? "open" : "collapsed"}
                    transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
                  >
                    <ChevronDownIcon />
                  </QuestionToggleIcon>
                </Question>
                <Answer
                  variants={{
                    open: { opacity: 1, height: "auto", marginTop: "16px" },
                    collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                  }}
                  initial="collapsed"
                  animate={activeQuestionIndex === index ? faq.totalprice !== undefined && "open" : "collapsed"}
                  transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                  <div>
                    <p>India TN IGST ({faq.gstrate})</p>
                    <p>Fuel Surcharge ({faq.fuelsurgetaxrate})</p>
                    <p>Base Price</p>
                  </div>
                  <div>
                    <p align="right">₹ {faq.gst}</p>
                    <p align="right">₹ {faq.fuelsurgetax}</p>
                    <p align="right">₹ {faq.baseprice}</p>
                  </div>
                </Answer>
                {faq.totalprice !== undefined ?
                  <BuyButton2 onClick={() => onService((faq.vendor).toLowerCase())}>
                    <BuyButtonIcon className="icon" />
                    <span className="text">₹ {faq.totalprice}</span>
                  </BuyButton2> :
                  <BuyButton2 tw="bg-orange-400!">
                    <BuyButtonIcon className="icon" />
                    <span className="text">Unavailable</span>
                  </BuyButton2>}
              </FAQ>
            ))}
          </FAQSContainer>
        </Column>
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
